export const timeZone = 'Asia/Bangkok'
export const timeFormat = 'YYYY-MM-DDTHH:mm:ss'
export const dateFormatView = "ddd DD  MMMM YYYY"
export const timeFormatView = "HH:mm"
export const dateTimeFormatView = "ddd DD  MMMM YYYY HH:mm"
export const dateFormat = "YYYY-MM-DD"

export const daysInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const weekly = ['First', 'Second', 'Third', 'Fourth', 'Last'];

export const dateDisplay = 'DD, MMM YYYY'
export const dateTimeDisplay = 'DD, MMM YYYY, HH:mm'
export const timeDisplay = 'HH:mm'

export const groupFBSbyCatagory = (fbsList) => {
    let result = []
    if (fbsList && fbsList.length > 0) {
        fbsList.forEach(element => {
            const { fbCategoryId } = element
            const { name, _id } = fbCategoryId ? fbCategoryId : null
            let findIndexCategory = result.findIndex(r => r.fbCategoryId === _id)
            if (findIndexCategory > -1) {
                let data = result[findIndexCategory].data
                result[findIndexCategory].data = data.concat(element)
            } else result.push({ fbCategoryId: _id, name: name, data: [element] })
        });
    }
    return result
}

export const defaultEventPinEmail = "<p>You've been invited to the meeting at <u>{{eventDate}}</u></p>" +
    "<p>Invited by: {{organizerName}}</p>" +
    "<p>Subject: {{subject}}</p>" +
    '<p>Your PIN Code: <b><u> {{pinCode}}</u></b></p>' +
    '<p>Your QR Code:</p>' +
    '{{qrCodeImage}}' +
    '<p>Note: You can use the PIN or QR Code to perform any transaction at the meeting room.</p>' +
    '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' +
    "<p><br/><p>Sincerely, <br/>Administrator Team</p>"

export const defaultCheckinEmail = "<p>Dear. {{attendeeName}}</p>" +
    "<p>You've successfully checked in the meeting at  <u>{{checkinTime}}</u> </p>" +
    "<p>Invited by: {{organizerName}} </p>" +
    "<p>Subject: {{subject}} </p>" +
    "<p>Welcome to the meeting room.</p>" +
    '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' +
    "<p><br/><p>Sincerely, <br/>Administrator Team</p>"

export const defaultCheckoutEmail = "<p>Dear. {{attendeeName}}</p>" +
    "<p>You've successfully checked out the meeting at  <u>{{checkinTime}}</u> </p>" +
    "<p>Invited by: {{organizerName}} </p>" +
    "<p>Subject: {{subject}} </p>" +
    "<p>Have a good day.</p>" +
    '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' +
    "<p><br/><p>Sincerely, <br/>Administrator Team</p>"

export const defaultReminderEmail = "<p>Dear {{fullName}} </p>" +
    "<p>This is to remind you that you have a meeting at {{eventDateTime}} at {{location}}</p>" +
    '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' +
    "<p><br/><p>Sincerely, <br/>Administrator Team</p>"

export const defaultApproveEmail = ""

export const defaultForgotPassword = "<p>Dear. {{fullname}}</p>" +
    "<p> You received this email because you requested forgot password on<u> {{requestDateTime}}</u> </p>" +
    "<p>Please click link below for confirm your request.</p>" +
    '<a href = "{{resetUrl}}">Click Here</a>' +
    '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' +
    "<p><br/><p>Sincerely, <br/>Administrator Team</p>"

export const defaultResetPassword = "<p>Dear. {{fullname}}</p>" +
    "<p> You received this email because you requested for reset password on<u>{{requestDateTime}}</u> </p>" +
    "<p>Please use below Username and Password at frontend.</p>" +
    '<p><b>User: </b/>{{userEmail}}</p>' +
    '<p><b>Password: </b/>{{newPassword}}</p>' +
    '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' +
    "<p><br/><p>Sincerely, <br/>Administrator Team</p>"

export const defaultAdminResetPassword = "<p>Dear. {{fullname}}</p>" +
    "<p>You are receiving this email because you're request for reset password on <u>{{requestDateTime}}</u> </p>" +
    "<p>Please log on at Frontend by this username , password as below.</p>" +
    '<p><b>User: </b/>{{userEmail}}</p>' +
    '<p><b>Password: </b/>{{newPassword}}</p>' +
    "<p><br/><p>Sincerely, <br/>Administrator Team</p>"


export const defaultEventRecurrentPinEmail = "<p>You've been invited to the meeting at <u>{{eventDateTime}}</u></p>" +
    "<p>Invited by: {{organizerName}}</p>" +
    "<p>Subject: {{subject}}</p>" +
    '<p>Your PIN Code: <b><u> {{pinCode}}</u></b></p>' +
    '<p>Your QR Code:</p>' +
    '{{qrCodeImage}}' +
    '<p>Note: You can use the PIN or QR Code to perform any transaction at the meeting room.</p>' +
    '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' +
    "<p><br/><p>Sincerely, <br/>Administrator Team</p>"


    export const xxx11 = {
        "value":
        {
            "zone":null,
            "floor":{"_id":"5ddb4696d290d969af8b3d19","name":"1"},
            "building":{"_id":"5ddb4602d290d969af8b3d17","name":"B1"},
            "roomId":"5de48b65b3044c5513fb4122",
            "roomName":"Room 2",
            "roomEmail":"rm11@bainisysstg.onmicrosoft.com",
            "status":[
                {"module":"bacnet",
                "type":null,
                "controllers":[
                    {"mac":"00:30:de:45:ae:06",
                    "values":[
                        {"value":null,"code":["17"]}
                        ]
                    }
                ]},
                {"module":"din",
                "type":"MOTION",
                "controllers":[
                    {"mac":"00:30:de:45:ad:ee",
                    "values":[
                        {"value":null,"serial":[1,2]}]
                    },
                    {"mac":"00:30:de:41:3b:7d",
                    "values":[
                        {"serial":[1],"value":"ON"}
                    ]}
                ]},
                {"module":"dout",
                "type":"LIGHT",
                "controllers":[
                    {"mac":"00:30:de:45:ad:ee",
                    "values":[
                        {"value":null,"serial":[1,4]}
                    ]}
                ]},
                {"module":"dmx",
                "type":null,
                "controllers":[
                    {"mac":"00:30:de:41:3b:7d",
                    "values":[
                        {"serial":[1],"value":{"r":"56","g":"80","b":"223"}}
                    ]}
                ]},
                {"module":"dali",
                "type":null,
                "controllers":[
                    {"mac":"00:30:de:41:3b:7d",
                    "values":[
                        {"serial":[1],"value":"100"}
                    ]}
                ]}
        ]}
    }

    export const xxx10 = {
        "value":
        {
            "zone":null,
            "floor":{"_id":"5ddb4696d290d969af8b3d19","name":"1"},
            "building":{"_id":"5ddb4602d290d969af8b3d17","name":"B1"},
            "roomId":"5de48b65b3044c5513fb4122",
            "roomName":"Room 10",
            "roomEmail":"rm10@bainisysstg.onmicrosoft.com",
            "status":[
                {"module":"bacnet",
                "type":null,
                "controllers":[
                    {"mac":"00:30:de:45:ae:06",
                    "values":[
                        {"value":null,"code":["16"]}
                        ]
                    }
                ]},
                {"module":"din",
                "type":"MOTION",
                "controllers":[
                    {"mac":"00:30:de:45:ad:ee",
                    "values":[
                        {"value":null,"serial":[1,2]}]
                    },
                    {"mac":"00:30:de:41:3b:7d",
                    "values":[
                        {"serial":[1],"value":"ON"}
                    ]}
                ]},
                {"module":"dout",
                "type":"LIGHT",
                "controllers":[
                    {"mac":"00:30:de:45:ad:ee",
                    "values":[
                        {"value":null,"serial":[1,4]}
                    ]}
                ]},
                {"module":"dmx",
                "type":null,
                "controllers":[
                    {"mac":"00:30:de:41:3b:7d",
                    "values":[
                        {"serial":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],"value":{"r":"0","g":"0","b":"0"}}
                    ]}
                ]},
                {"module":"dali",
                "type":null,
                "controllers":[
                    {"mac":"00:30:de:41:3b:7d",
                    "values":[
                        {"serial":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],"value":"100"}
                    ]}
                ]}
        ]}
    }


// WEBPACK FOOTER //
// ./src/lib/setting.js